import React from 'react';

const MoreSports = () => {
  const cards = [
    {
      image: "https://images.unsplash.com/photo-1551698618-1dfe5d97d256?auto=format&fit=crop&w=900&q=80",
      tag: "X Games / Action",
      title: "Extreme Action & Freestyle",
      description: "Big air, tricks and gravity-defying competition."
    },
    {
      image: "https://images.unsplash.com/photo-1542751371-adc38448a05e?auto=format&fit=crop&w=900&q=80",
      tag: "Esports",
      title: "Global Esports Tournaments",
      description: "Top teams, packed arenas and high-stakes brackets."
    },
    {
      image: "https://plus.unsplash.com/premium_photo-1721756020219-d9792009267e?w=600&auto=format&fit=crop&q=60",
      tag: "Fishing",
      title: "Competitive Angling & Events",
      description: "Cast-offs, finals and unique outdoor competitions."
    },
    {
      image: "https://images.unsplash.com/photo-1485846234645-a62644f84728?auto=format&fit=crop&w=900&q=80",
      tag: "Originals",
      title: "Docs & Behind-The-Scenes",
      description: "Story-driven series featuring top athletes and teams."
    }
  ];

  return (
    <section className="section">
      <div className="section-title">More Sports on Our Partners</div>
      <div className="section-sub">Our streaming partners may also include action sports, esports, fishing and more in different regions – a growing destination for niche and emerging sports fans.</div>

      <div className="grid-4">
        {cards.map((card, index) => (
          <div key={index} className="card">
            <img src={card.image} alt={card.tag} />
            <div className="card-body">
              <div className="card-tag">{card.tag}</div>
              <h3>{card.title}</h3>
              <p>{card.description}</p>
              <a href="https://www.dazn.com/en-IN/welcome/en-IN/welcome">Explore →</a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default MoreSports;
